import * as React from 'react'
import { queueActions } from '@/scopes/checkout/groups/domain/actions/queue'

interface QueueDependencies {
  actions?: ReturnType<typeof queueActions>
}

const defaultDependencies: QueueDependencies = {}

const QueueDependenciesContext = React.createContext<QueueDependencies>(defaultDependencies)

export function QueueDependenciesProvider({
  children,
  dependencies = defaultDependencies,
}: React.PropsWithChildren<{ dependencies?: QueueDependencies }>) {
  return <QueueDependenciesContext value={dependencies}>{children}</QueueDependenciesContext>
}

export function useQueueDependencies() {
  return React.use(QueueDependenciesContext)
}

export function useQueueActions() {
  const { actions } = useQueueDependencies()
  if (!actions) {
    throw new Error('actions not provided')
  }
  return actions
}
